import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdDiscountConfig, EdDiscountConfigApi } from '../tokens/ed-discount-config.token';

/**
 * REST implementation of the E-D SDF discount-configuration API (BRS Ch.3 §3.5.2, EM-772).
 *
 *   GET /services/embedded/api/business/ed/discount-config
 *   PUT /services/embedded/api/business/ed/discount-config
 *
 * The calling E-D is resolved server-side from the JWT (Rule 22 — no id in the URL).
 * REST-only (Rules 07/10). Bound to ED_DISCOUNT_CONFIG in mock-data.providers.ts.
 */
@Injectable({ providedIn: 'root' })
export class EdDiscountConfigRestService implements EdDiscountConfigApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/business/ed/discount-config`;

  getConfig(): Observable<EdDiscountConfig> {
    return this.http.get<EdDiscountConfig>(this.base);
  }

  saveConfig(config: EdDiscountConfig): Observable<EdDiscountConfig> {
    return this.http.put<EdDiscountConfig>(this.base, config);
  }
}
